import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import Icon from 'components/Icon'
import SessionStore from 'iam/SessionStore'
import { Id } from 'types/definitions'
import WorkspaceSelectorState from './WorkspaceSelectorState'
import WorkspaceSignupState from '../WorkspaceSignupContainer/WorkspaceSignupState'
import styles from '../styles.sass'
import Checkbox from 'components/Checkbox'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  selectorState: WorkspaceSelectorState
  workspaceSignupState: WorkspaceSignupState
  sessionStore: SessionStore
}

export default observer(function WorkspaceSelector({
  selectorState,
  sessionStore,
  workspaceSignupState,
}: Props) {
  const hasAdminJobViewPermission = selectorState.memberships.some((i) =>
    i.member.hasPermission('ADMIN_JOB_VIEW'),
  )

  return (
    <div
      className={cx(
        styles.selector,
        selectorState.isSelectorOpen ? styles.expanded : styles.closed,
      )}
      data-test="WorkspaceSelector"
    >
      <div className={styles.titlebar}>
        <h4>Switch Workspace</h4>
      </div>
      {hasAdminJobViewPermission && (
        <div className={styles.defaultToAllWorkspacesCheckboxContainer}>
          <Checkbox
            checked={selectorState.isDefaultToAllWorkspaces}
            onChange={() => selectorState.toggleDefaultToAllWorkspaces()}
            data-test="workspace-selector-all-workspaces-checkbox"
          />
          <p>
            Default to <strong>All Workspaces</strong>
          </p>
        </div>
      )}
      <div className={styles.searchbar}>
        <div className={styles.searchContainer}>
          <input
            type="text"
            placeholder="Search"
            value={selectorState.searchText}
            onChange={(e) => selectorState.setSearchText(e.target.value)}
          />
          <Icon name="search" />
        </div>
      </div>
      <div className={styles.list}>
        {selectorState.filteredMemberships.map(({ workspace }) => (
          <div className={styles.listItem} key={Id.assert(workspace.id)}>
            <button
              data-test={`WorkspaceItem(${workspace.slug})`}
              className={cx(
                styles.listItemContent,
                sessionStore.hasWorkspaceSelected &&
                  sessionStore.workspace.id === workspace.id &&
                  styles.selected,
              )}
              onClick={() => selectorState.selectWorkspace(workspace)}
            >
              <div className={styles.icon}>
                <img src={workspace.branding.logos.icon} />
              </div>
              <div className={styles.text}>
                <h4 className={styles.name}>{workspace.name}</h4>
                <p className={styles.slug}>{workspace.slug}</p>
              </div>
              <div className={styles.arrow}>
                <Icon name="arrow" />
              </div>
            </button>
          </div>
        ))}
        <div className={styles.listItem}>
          <button
            title="Add workspace"
            className={styles.listItemContent}
            onClick={() => workspaceSignupState.openWorkspaceSearch()}
          >
            <div className={styles.icon}>
              <Icon name="add" />
            </div>
            <div className={styles.text}>
              <h4>Add new workspace</h4>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
})
